module.exports = __webpack_public_path__ + "static/nightwalker-9fc6e429f8d943fe5e03cfda32601e74.png";